import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _loading$ = signal(false);
  public loading$ = this._loading$.asReadonly();

  private requestCount = 0;

  showLoader(): void {
    if (this.requestCount === 0) {
      this._loading$.set(true);
    }
    this.requestCount++;
  }

  hideLoader(): void {
    this.requestCount--;
    if (this.requestCount === 0) {
      this._loading$.set(false);
    }
  }
}
